import { Form } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import React from 'react';
import type Filters from '../../interfaces/pluriannuelle/filters';

interface PluriannuelleFiltersProps {
	filters: Filters;
	onChangeYear: (e: React.FocusEvent<HTMLInputElement>) => void;
	onChangePeriode: (
		e: React.ChangeEvent<HTMLSelectElement>,
		{ value }: { value: string },
	) => void;
}

export const OPTION_ANNEE_LIBRE = 'libre';

export const DEFAULT_OPTION_FILTERS = {
	key: '2026',
	text: '2026-2032',
	value: '2026',
	startYear: '2026',
	endYear: '2032',
} as const;

const OPTIONS = [
	{
		key: '2020',
		text: '2020-2026',
		value: '2020',
		startYear: '2020',
		endYear: '2026',
	},
	DEFAULT_OPTION_FILTERS,
	{
		key: '2032',
		text: '2032-2038',
		value: '2032',
		startYear: '2032',
		endYear: '2038',
	},
	{
		key: OPTION_ANNEE_LIBRE,
		text: 'Saisie libre',
		value: OPTION_ANNEE_LIBRE,
	},
] as const;

const PluriannuelleFilters = ({
	filters,
	onChangeYear,
	onChangePeriode,
}: PluriannuelleFiltersProps) => {
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			e.currentTarget.blur();
		}
	};

	return (
		<Form>
			<Form.Group>
				<Form.Field
					control={Combobox}
					data-testid="periodeCombobox"
					label="Période de mandature"
					onChange={onChangePeriode}
					options={OPTIONS}
					selection
					value={filters.periode}
					width={5}
				/>
				{filters.periode === OPTION_ANNEE_LIBRE && (
					<>
						<Form.Input
							input={{ 'data-testid': 'startYearInput', maxlength: 4 }}
							label="Année début"
							name="startYear"
							onBlur={onChangeYear}
						/>
						<Form.Input
							input={{ 'data-testid': 'endYearInput', maxlength: 4 }}
							label="Année fin"
							name="endYear"
							onBlur={onChangeYear}
							onKeyDown={handleKeyDown}
						/>
					</>
				)}
			</Form.Group>
		</Form>
	);
};

export default PluriannuelleFilters;
